export const RE_PCNO = /^[0-9]{1,8}$/;

export const RE_NAME = /^[a-zA-Z0-9\s\u4e00-\u9fa5]+$/;

export const RE_USERNAME = /^[a-zA-Z\s\u4e00-\u9fa5·]+[a-zA-Z\s\u4e00-\u9fa5]$/;

export const RE_PHONE = /^1[3457689]\d{9}$/;

export const RE_HKPHONE = /^([6|9])\d{7}$/;

export const RE_PASSWORD = /(?=.*[0-9])^[A-Za-z].{5,}$/;

export const RE_VERCODE = /^[a-zA-Z0-9]+$/;

export const RE_EMAIL = /^[\.a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;

export const RE_CARD = /^[a-zA-Z0-9]+$/;

export const RE_BANKACCOUNT = /^[\d]+$/;

export const RE_ADDRESSDETAIL = /^[-#()0-9a-zA-Z\u4e00-\u9fa5\uff08\uff09]+$/;


export const RE_ZIP = /^\d{6}$/;